import {useMutation, UseMutationOptions, useQueryClient} from '@tanstack/react-query'
import {errorHandler, makeHttpAuthorizationHeader, raise} from 'src/helpers/helpers.ts'
import {QUERY_KEYS} from 'src/queryClient.ts'
import {useUserStore} from 'src/features/user/store.ts'
import {
    httpChangePhotographerStatus,
    HttpChangePhotographerStatusOptions
} from 'src/features/admin/services/admin.http.ts'
import {Freelancer} from '../types'

export const useAdminChangeFreelancerStatus = (
    photographerId: Freelancer['id'],
    options?: Omit<
        UseMutationOptions<unknown, unknown, HttpChangePhotographerStatusOptions['payload']>,
        'queryKey' | 'queryFn'
    >
) => {
    const queryClient = useQueryClient()
    const adminAccessToken = useUserStore(store => store.adminAccessToken) ?? raise('adminAccessToken is nullish')

    return useMutation<unknown, unknown, HttpChangePhotographerStatusOptions['payload']>({
        mutationFn: payload =>
            httpChangePhotographerStatus({
                headers: makeHttpAuthorizationHeader(adminAccessToken),
                urlParams: {photographerId},
                payload
            }),
        ...options,
        onSuccess: (data, variables, context) => {
            queryClient.cancelQueries([QUERY_KEYS.PARTNERS])
            queryClient.invalidateQueries([QUERY_KEYS.PARTNERS])

            options?.onSuccess?.(data, variables, context)
        },
        onError: (error, variables, context) => {
            errorHandler(error)
            options?.onError?.(error, variables, context)
        }
    })
}
